<template>
    <div class="newsContent scrollView" @scroll="elementScroll($event)" :class="{black:data.type==6}" ref="scrollView">

        <div class="content allowSelect">

            <div class="content-title">
                <span>{{data.title}}</span>
                <div class="content-title-listen" @click="playvoice()" v-if="data.voice_status" :class="{roating:state.playState==='playing'}"></div>
            </div>
            <div class="zw_info">
                <div class="zw_info_row">

                    <span>{{data.author}}</span>
                    <div></div>
                    <span>{{parseInt(data.pv_num)>10000?(parseInt(data.pv_num)/10000).toFixed(1)+'万':data.pv_num}} 人已阅读</span>
                </div>
                <div class="zw_info_school" v-if="data.reprint"><span>{{data.reprint}}</span></div>
            </div>

            <div class="description" v-if="data.desc && data.desc.indexOf('求证新闻真相')==-1">
                {{data.desc}}
            </div>
            <div class="zw-content article-content font-nomal" v-html="data.content" @click="DetailClick($event)"></div>

            <div class="zw_wytg" @click="opentougao()">
                <img src="../assets/zw_wotg.png">
            </div>






        </div>
        <div class="line"></div>

        <!--        相关新闻-->
        <div class="more_news" v-if="data.about_list && data.about_list.length>0">
            <div class="more_news_title">
                相关作文
            </div>
            <div class="news-list-item font-nomal"  v-for="item in data.about_list" @click="openContent(item)">
                <div class="news-list-item-row" >
                    <div class="news-list-item-row-left">
                        <div class="news-list-item-title text-overflow">
                            {{item.title}}
                        </div>
                        <div class="zw-more-item-desc" v-if="!item.thumb">{{item.content}}</div>
                        <div class="news-list-item-date ">
                            <span class="is_stick" v-if="item.is_stick">置顶</span>
                            <!--                            <span class="is_spec" v-if="item.is_spec">专栏</span>-->
                            <span v-if="data.author">{{item.author}}</span>
                            <span>{{item.publish_time | getDateDiff}}</span>
                        </div>
                    </div>
                    <img v-if="item.thumb" @error="errimg($event)" :src="item.thumb+'?x-oss-process=image/resize,m_lfit,h_200,w_360'" class="news-list-item-img news-list-item-img-right" >
                </div>

            </div>
            <div class="line"></div>

        </div>
        <!-- 全部评论-->
        <div class="replay-containner">
            <div class="replay-containner-title">全部评论</div>
            <div class="replay-empty" v-if="replaylist.length === 0">没有评论快来抢沙发吧</div>
            <div class="replay-item font-nomal" v-for="item in replaylist" v-else>
                <!--                <img class="replay-item-avatar" :src="item.head_img" @error="setdefaultImg($event)">-->
                <img class="replay-item-avatar" :src="item.head_img" @error="setdefaultImg($event)">

                <div class="replay-item-c">
                    <div class="replay-item-name">
                        <div class="replay-item-name-user">{{item.user_name}}</div>
                        <!--                            <div class="replay-item-name-praise">-->
                        <!--                                <img src="../../../image/replay-praise.png">-->
                        <!--                                <span>赞</span>-->
                        <!--                            </div>-->
                    </div>

                    <div class="replay-item-content" v-html="item.content"></div>
                    <div class="replay-item-info">
                        <span>{{item.create_time}}&nbsp;</span>
                        <i></i>
                    </div>
                </div>
            </div>


        </div>


        <a @click="opendownload()" class="bottom_btn_">打开APP查看更多精彩评论</a>



        <div class="c-loading" v-if="loading">
            <div class="c-loading-c">
                <img src="../assets/loading.svg">
                <div>加载中...</div>
            </div>

        </div>

    </div>
</template>
<style scoped>

  @import '../assets/css/listcomponentscss.css';
  .newsContent{ display: block !important;}
  .content{ padding:15px; padding-top: 0}
  .back img{ height: 18px; display: block}
  .line{ width: 100%; height: 6px; background-color: #f0f0f0}

  .v-header{ position: relative;}
  .v-header-back{ left: 15px; z-index: 100; position: absolute; }
  .v-header-back img{ height: 18px; display: block}
  .content-title{ font-size: 26px; padding: 20px 0; letter-spacing: 1px; line-height: 1.4; color: #000 }
  .content-title span{ vertical-align: middle}
  .content-text{ font-size: 14px; color: #8e8e8e}


  .article-content>div,.article-content>p{ max-width: 100% !important; }
  .article-content img{ max-width: 100%; object-fit: contain}
  .article-content{ font-size: 20px; line-height: 1.8}

  .van-info{ font-size: 9px !important;}
  .article-content span,.article-content strong,.article-content a{ display: inline !important;}
  .article-content a{text-decoration: underline; display: inline; color: #0000ee}
  .article-content video{ max-width: 100%; display: block; margin: 10px auto}

  .wrapper img{ max-width: 100%; object-fit: contain}
  .content-title-listen{ background-color: #ff6c6c; display: inline-block; vertical-align: middle; margin-left: 4px; width: 30px; height: 30px;
    border-radius: 50%; font-size: 0; line-height: 30px; text-align: center;background-image: url(../assets/listen.svg);background-repeat: no-repeat;background-position: center center;
    background-size: 20px auto}
  .content-title-listen img{ height: 20px; display:inline}

  .show .scrollView,.show .content-replay-controller,.show .video-placeholder,.show .wrapper{ display: block}

  .news-list-item-scrolltext.fixed{ bottom: 50px !important;}
  .info-row-item{ display: flex; align-items: center;  padding: 0 6px; font-size: 12px; height: 20px; line-height: 20px; border-radius: 1px;

  }
  .info-row-item i{ font-style: normal; font-size: 12px}
  .info-row-item svg{ width: 15px; height: 18px; margin-right: 3px; }
  .info-row-item svg path{ fill: #818181}
  .info-row-item .news-list-replay-icon{width: 15px; height: 15px;}
  .info-from{ font-size: 14px; color: #323232;display: flex; align-items:center; padding-top: 6px;white-space: nowrap}
  .info2 .info-from{font-size: 16px;}
  .info-from .info-from-yc{ display: flex; margin-left: 5px; padding: 0 5px; background-color: #f3f3f3; color: #a7a7a7; border-radius: 2px; height: 14px; line-height: 14px; font-size: 9px;}
  .info-publish_time{ font-size: 10px; line-height: 20px}
  .xinagq{ font-size: 14px; flex: 1; height: 32px; display: flex; align-items: center; color: #1989fa; text-align: center;}

  .article_{ width: 100%;  padding:20px 10px; font-size: 12px; line-height: 24px; border: 1px solid red; color: #000; position: relative;
    margin-top: 30px; background-color: #f0f0f0;
  }
  .article__title{ font-size: 18px; font-weight: bold; text-align: justify-all; background-color: #fff; position: absolute; left: 50%; top: 0;
    transform: translateY(-5px) translateX(-50%);line-height: 10px}
  .article_ .article__row{ display: flex; align-items: center; justify-content: space-between}
  .more_news_title{ font-size: 20px; line-height: 30px; padding-left: 10px; border-left: 5px solid red; margin-top: 15px}
  .xinagq img{ height: 100%}

  .header-end{ color: #1989fa}
  .news-list-item-scrolltext.fixed{ border-bottom: none}
  .xinagq .van-notice-bar{ background-color: transparent !important; color: #1989fa !important; padding-left: 0 !important;}
  .van-overlay{ background-color: rgba(0,0,0,0.3) !important;}
  .roating{ animation:roate 5s infinite linear}
  .zw_wytg{ display: flex; justify-content: center; align-items: center; margin: 30px}
  .zw_wytg img{ height: 80px; display: block}
  @keyframes roate {
      0%{
          transform: rotate(0deg);
      }
      100%{
          transform: rotate(360deg);
      }
  }
  .bottom_btn_ {
      display: block;
      width: 80%;
      margin: .6rem auto;
      border-radius: 20px;
      text-align: center;
      color: #fff;
      background: #ee1a1a;

      font-size: 16px;
      line-height: 40px;
      height: 40px;
  }
    .black{ background-color: #2c2c2c}







  .img{ display: block; width: 100%; height: 100%; object-fit: cover}






  .zw-content{ font-size: 18px; line-height: 34px; letter-spacing: 1px; padding: 0 8px}
  .zw_info_school span{ background-color: #f0f3fc; display: inline-block; padding: 0 5px; border-radius: 2px; font-size: 12px; color: #536690; height: 20px; line-height: 20px}
  .zw_info_row{ display: flex; align-items: center; font-size: 12px; color: #9c9c9c;}
  .zw_info_row div{ height: 12px; width: 1px;background-color: #9c9c9c; margin: 0 8px;}
  .zw_info{ padding:10px; padding-top: 0;  font-size: 12px; color: #818181;line-height: 20px; margin-bottom:15px;}
  .dianpin-box{ margin-top: 15px}
  .dianpin-item{ background-color: #f0f0f0; border-radius: 10px; padding: 15px; border:1px solid #ff9a00; background-image: url("../assets/zw_dianpin.png");
      background-repeat: no-repeat; background-position: right top; background-size: 60px 60px; display: flex; justify-content: space-between; margin-bottom: 8px}
  .dianpin-item-L{ width: 40px; height: 40px;}
  .dianpin-item-L img{ width: 40px; height: 40px; border-radius: 25px}
  .dianpin-item-R{ flex: 1; margin-left: 10px;}

  .dianpin-item-user{ height: 40px; line-height: 40px; font-size: 18px; font-weight: bold; color: #536690}
  .dianpin-item-content{ font-size: 16px; color: #536690;line-height: 28px;  text-align: justify}

  .description{ background-color: #f6f6f6; color: #7c7c7c; font-size: 13px; padding: 13px 15px; margin-top: -15px; margin-bottom: 10px;
  }

  .news-list-item-row-left{ height: auto !important;}
  .news-list-item-row-left .news-list-item-title{ max-height: 44px; height: auto !important;}
  .zw-more-item-desc{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-size: 12px;
      color: #9c9c9c;
      line-height: 16px;
      height: 32px;
      margin-bottom: 5px;
  }
</style>
<style>
.zw-content p img{ display: block}
</style>
<script>

    import { ImagePreview } from 'vant';
    import layVideo from '@/components/Video.vue'
    import config from '../config'
    import utils from '../utils'
    import { Toast } from 'vant';
    import request from "../utils/request";
    export default {
        data(){
            return{
                data:{
                    about_list:[],

                },
                replaylist:[],
                live_lists:[],
                page:1,
                replaypage:1,
                bottomDistance:100,
                showad:false,
                height:window.innerHeight - 100,
                state:{
                    playState:'',
                    duration:''
                },//音频播放器状态
                imglivepage:1,
                pageid:this.$route.params.id,
                live_loaded:false,
                loading:true,
                dianpin_list:[]
            }
        },
        name: 'newsContent',
        created() {

            this.getData();
            this.getreplay();

            this.createAudio();
            this.height = window.innerHeight -100;
        },
        filters: {
            time: function time(t) {
                if (!t) return "";
                var i = new Date(1e3 * t),
                    e = i.getFullYear(),
                    s = i.getMonth() + 1,
                    a = i.getDay();
                i.getHours(), i.getMinutes(), i.getSeconds();
                return e + "-" + s + "-" + a;
            },
            getDateDiff: function getDateDiff(t) {
                if (t) {
                    var i = new Date().getTime() - Date.parse(t.replace(/-/gi, "/"));
                    if (i < 0) return;
                    var e = i / 2592e6,
                        s = i / 6048e5,
                        a = i / 864e5,
                        n = i / 36e5,
                        o = i / 6e4;
                    return e >= 1 ? parseInt(e) + "月前" : s >= 1 ? parseInt(s) + "周前" : a >= 1 ? parseInt(a) + "天前" : n >= 1 ? parseInt(n) + "小时前" : o >= 1 ? parseInt(o) + "分钟前" : "刚刚";
                }
            }
        },
        components: {
            [ImagePreview.Component.name]: ImagePreview.Component,
            layVideo
        },
        mounted() {
            document.querySelector(".toplink").style.display = 'block'
        },
        methods:{

            //音频播放器
            createAudio(){
                let state = this.state
                var audio = document.createElement('audio');
                audio.onended = function (event) {
                    state.playState = 'end';

                }; //播放


                audio.onplay = function (event) {
                    state.playState = 'playing';
                    console.log('播放');


                }; // //加载出错


                audio.onerror = function (event) {
                    state.playState = 'error';
                    console.log('加载出错');
                }; //缺少数据缓存等待中


                audio.onwaiting = function (event) {
                    state.duration = audio.duration;
                    state.currentTime = audio.currentTime;
                    state.playState = 'waiting';
                }; //视频播放中


                audio.onplaying = function (event) {
                    state.playState = 'playing';


                }; //可以播放


                audio.oncanplay = function (event) {
                    state.duration = audio.duration;
                    state.currentTime = audio.currentTime;
                }; //暂停


                audio.onpause = function (event) {
                    state.playState = 'pause';
                    console.log('暂停');
                }; //当媒介资源元素突然为空时（网络错误、加载错误等）运行脚本


                audio.onemptied = function () {
                    state.playState = 'error';
                };

                audio.ondurationchange = function () {
                    state.duration = audio.duration;
                    state.currentTime = audio.currentTime;

                };
                this.audio = audio;
            },

            opentougao: function opentougao() {
                this.$router.push({name:"zwTougao"})

            },
            getData(){
                let id = this.pageid ?this.pageid:this.$route.params.id;
                request.getNewsContent(id,(res)=>{
                    var _this10 = this;

                    if(!res.data){
                        alert("作文不存在");
                        return
                    }
                    this.loading =false;
                    res.data.content = res.data.content.replace(/<video [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, f) {
                        var reg = /<video[^>]*src[=\'\"\s]+([^\"\']*)[\"\']?[^>]*>/gi;
                        var url = '';

                        while (reg.exec(match)) {
                            url = RegExp.$1;
                        }

                        if (url) {
                            return '<video controls webkit-playsinline="true" x5-playsinline="true" playsinline="true"  x-webkit-airplay="true" src="' + url + '" poster="' + url + '?x-oss-process=video/snapshot,t_2000,f_jpg,m_fast" >';
                        }

                        return '';
                    });

                    var imgnumber = -1;
                    var content_imgs = [];
                    res.data.content = res.data.content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, f) {
                        var reg = /<img[^>]*src[=\'\"\s]+([^\"\']*)[\"\']?[^>]*>/gi;
                        var src = '';

                        while (reg.exec(match)) {
                            src = RegExp.$1;
                        }

                        if (src) {
                            content_imgs.push(src);
                            imgnumber++;

                            if (src.indexOf('img2.yitoutiao.net') !== -1) {
                                return "<img src='" + src + "?x-oss-process=image/resize,m_lfit,w_700' data-index='" + imgnumber + "'>";
                            } else {
                                return "<img src='" + src + "' data-index='" + imgnumber + "'>";
                            }
                        } else {
                            return '';
                        }
                    });
                    res.data.content = res.data.content.replace(/<a [^>]*href=['"]([^'"]+)[^>]*>/gi, function (match, f) {
                        var reg = /<a[^>]*href[=\'\"\s]+([^\"\']*)[\"\']?[^>]*>/gi;
                        var url = '';

                        while (reg.exec(match)) {
                            url = RegExp.$1;
                        }

                        if (url) {
                            return "<a href='" + url + "' target=\"_bank\">";
                        }
                    });

                    var font18 = /font\-size\:\s18px/gim;
                    res.data.content = res.data.content.replace(font18, '');
                    var liheight = /line\-height\:\s2em/gim;
                    res.data.content = res.data.content.replace(liheight, '');
                    _this10.content_imgs = content_imgs;

                    if (res.data.ad_info && res.data.ad_info.img_url) {
                        _this10.showad = true;
                    }

                    if(res && res.code==200){
                        this.data = res.data
                    }


                    if(res.data.type==6){
                        var imglist = [];
                        for (var i = 0; i < res.data.thumb.length; i++) {
                            imglist.push({
                                img: res.data.thumb[i],
                                text: res.data.imgtxt[i] ? res.data.imgtxt[i] : res.data.title
                            });
                        }
                        _this10.imglist = imglist;
                    }

                    //

                    request.getWeixinShanre(location.href,(s_res)=>{
                        let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
                        let shareconfig = {appId,timestamp,nonceStr,signature};
                        if(utils.is_weixin()){
                            if(res.data){
                                var title = res.data.title?res.data.title:"看度时政";



                                var regex = /(<([^>]+)>)/ig;
                                var result = '';
                                try{
                                    result = res.data.content.replace(regex, "");
                                    result = res.data.content.replaceAll('&nbsp;', "");


                                }catch (err){

                                }

                                // title = "作文展播 | "+title
                                let sharedata = {
                                    title:title,
                                    desc:result,
                                    link:location.href,
                                    imgUrl:thumb
                                };
                                utils.setWeiXinShare(sharedata,shareconfig,false)
                            }

                        }
                    });

                    try{
                        this.$refs.scrollView.scrollTop =0
                    }catch (e) {
                        console.log(e)
                    }

                })
            },
            getreplay: function getreplay() {
                var page = this.replaypage;
                let id = this.pageid ?this.pageid:this.$route.params.id;
                request.getNewsContentReplay(id, page,  (res, err)=> {
                    if (err) {
                        return;
                    }

                    if (res.code == 200) {
                        this.replaypage++;

                        var replaylist = this.replaylist.concat(res.data);
                        console.log(replaylist)
                        this.replaylist = utils.arrayDelRepeat(replaylist, 'com_id');
                    }
                });
            },

            playvoice(){
                if(!this.state.playState){
                    let voice = '';
                    if (this.data['voice_pth_girl']) {
                        voice = this.data['voice_pth_girl'];
                    } else if (this.data['voice_pth_man']) {
                        voice = this.data['voice_pth_man'];
                    } else if (this.data['voice_sch_girl']) {
                        voice = this.data['voice_sch_girl'];
                    } else if (this.data['voice_yy']) {
                        voice = this.data['voice_yy'];
                    }

                    this.audio.src=voice;
                    this.audio.play()
                }else if(this.state.playState==='playing'){
                    this.audio.pause()
                }else{
                    this.audio.play()
                }
            },
            setdefaultImg(e){
                var el = e.currentTarget;
                el.src = require('../assets/default_header.svg');
            },
            DetailClick(e){

                if (e.target.nodeName === 'IMG') {
                    var index = e.target.getAttribute('data-index');
                     ImagePreview({
                        images: this.content_imgs,
                        startPosition: parseInt(index),
                        onClose: function onClose() {// do something
                        }
                    });
                }
            },
            scrollbottom: function scrollbottom() {

                if(this.data.type==11){

                }else{
                    this.getreplay()
                }


            },
            elementScroll(e){

                //滚动到了底部
                if(this.scrollbottom){
                    var topheight = e.target.offsetHeight + e.target.scrollTop;
                    if((topheight+ this.bottomDistance) >= e.target.scrollHeight  && this.lastscroll<e.target.scrollTop){
                        if(this.scrollTopTimeOut){
                            clearTimeout(this.scrollTopTimeOut);
                            this.scrollTopTimeOut = false;
                        }
                        if(this.allow_run_scrollbottom){
                            this.scrollbottom();
                            this.allow_run_scrollbottom = false;
                        }
                        this.scrollTopTimeOut = setTimeout(()=>{
                            this.allow_run_scrollbottom = true;
                        },50);
                    }
                    this.lastscroll = e.target.scrollTop
                }

            },
            opendownload(){
                let id = this.pageid ?this.pageid:this.$route.params.id;
                let url = 'shenniao://app?code={"module":"zixun","page":"art_info","id":'+id+'}';
                setTimeout(()=>{
                    location.href = 'http://img2.yitoutiao.net/app/download.html';
                },500)
                location.href = url;
            },
            openContent(item){
                this.pageid = item.art_id;
                //location.href = 'http://img2.yitoutiao.net/t/index.html#NewsContent&id='+item.art_id;
                //location.href = 'http://localhost:8080/#/NewsContent&id='+item.art_id;
                this.replaylist = [];

                setTimeout(()=>{
                    this.getData();
                    this.getreplay();


                    setTimeout(()=>{
                        document.querySelector('.scrollView').scrollTop = 0;
                        location.href = 'http://img2.yitoutiao.net/t/index.html#zwContent&id='+item.art_id;
                    },200)
                },10);



            },
        }
    }
</script>
